<div class="h-full">
  <div class="bg-(--comp-app-bg) h-full">
    @if (isLoggedIn) {
      <app-header class="relative z-10"></app-header>
    }

    <div class="" [class]="isLoggedIn ? 'h-full pt-2 lg:h-[calc(100%-4.5rem)] ' : 'h-full'">
      <router-outlet class=""></router-outlet>
    </div>
  </div>
</div>
